import {
  CmpSelectBox,
  CmpDatePicker,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import { Box, TextField } from "@mui/material";

export default function WmsHead({
  xref,
  vRdxHead,
  xErrorMsg,
  vRdxuserLoc,
  fLocation,
  fReferenceNo,
  fReferenceNo_Enter,
  fDate,
  sDetail_Grid_Row,
  vMediaQuery,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        p: 2,
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      <Grid container spacing={2}>
        {[
          {
            label: "Sheet No",
            field: (
              <TextField
                variant="standard"
                value={vRdxHead.SheetNo}
                name="SheetNo"
                InputProps={{
                  readOnly: true,
                  style: {
                    fontSize: "18px",
                    textAlign: "center",
                  },
                }}
                error={xErrorMsg.SheetNo !== ""}
                helperText={xErrorMsg.SheetNo}
                inputProps={{
                  tabIndex: 1,
                }}
                fullWidth
              />
            ),
          },
          {
            label: "Ref.No",
            field: (
              <TextField
                inputRef={xref}
                variant="standard"
                value={vRdxHead.ReferenceNo}
                name="ReferenceNo"
                onChange={fReferenceNo}
                onKeyUp={fReferenceNo_Enter}
                InputProps={{
                  readOnly: sDetail_Grid_Row.length > 0,
                  style: {
                    fontSize: "18px",
                    textAlign: "center",
                  },
                }}
                error={xErrorMsg.ReferenceNo !== ""}
                helperText={xErrorMsg.ReferenceNo}
                inputProps={{
                  tabIndex: 3,
                }}
                fullWidth
              />
            ),
          },
          {
            label: "Location",
            field: (
              <CmpSelectBox
                xtabIndex="2"
                xValue={vRdxHead.Loc}
                xOnChange={fLocation}
                xName="Loc"
                xData={vRdxuserLoc}
                xError={xErrorMsg.Loc !== ""}
                xErrorMessage={xErrorMsg.Loc}
                xDisable={sDetail_Grid_Row.length > 0}
              />
            ),
          },
          {
            label: "Date",
            field: (
              <CmpDatePicker
                xtabIndex="4"
                xValue={vRdxHead.Date}
                xOnChange={fDate}
                xName="Date"
                xError={xErrorMsg.Date !== ""}
                xErrorMessage={xErrorMsg.Date}
                xDisable={sDetail_Grid_Row.length > 0}
              />
            ),
          },
        ].map((item, i) => (
          <Grid item xs={6} sm={6} key={i}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box
                sx={{
                  fontWeight: 600,
                  fontSize: vMediaQuery ? "12px" : "16px",
                  color: "#1976d2",
                  mb: 1,
                  letterSpacing: 0.5,
                }}
              >
                {item.label}
              </Box>

              <Box sx={{ fontSize: vMediaQuery ? "12px" : "25px" }}>
                {item.field}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
